/**
 * Created by OLD on 30/10/2015.
 */
define('sampleMain',[
  'module',
  'logger',
  'sampleMainRouter'
], function(
  module,
  Logger
) {
	'use strict';
	
  var Sample = {
    start: function() {
      Logger.log(module, 'starting SampleModule');
    },

    stop: function() {
      Logger.log(module, 'stopping SampleModule');
    }
  };

  module.exports = Sample;
});
